import React from "react"

export default props => (
  <div className="box-step is-fullwidth ">
    <div className="columns is-vcentered">
      <div className="column is-1 ">
        <div className="numberCircle">{props.numeral}</div>
      </div>
      <div className="column step-text">
        <span className="is-size-5 has-text-white has-text-weight-medium">
          {props.text}
        </span>
      </div>
    </div>
  </div>
)
